import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './EverythingSelection.css';

const EverythingSelection = () => {
    const navigate = useNavigate();
    const [userInput, setUserInput] = useState('');

    // Everything workout presets (from Android code)
    const everythingWorkouts = [
        { code: "lman", name: "leg arm abs hamstring Workout" },
        { code: "cgfish", name: "chest legs forearm bicep shoulder shoulder Workout" },
        { code: "bigroll", name: "back bicep legs arm core legs legs Workout" },
        { code: "ontheball", name: "core hamstring tricep shoulder chest back abs leg leg Workout" },
        { code: "rollwithit", name: "arm core leg leg chest bicep tricep shoulder bicep tricep Workout" },
        { code: "stopgym", name: "shoulder tricep core trap leg thigh arm Workout" },
        { code: "everyfit", name: "chest calves chest arm thigh forearm bicep tricep Workout" },
        { code: "krazy", name: "back arm abs oblique thigh Workout" },
        { code: "highfive", name: "shoulder bicep leg forearm bicep calves chest Workout" },
        { code: "mustwin", name: "arm glute shoulder tricep chest bicep hamstring Workout" },
        { code: "itis+", name: "bicep tricep bicep shoulder abs Workout" },
        { code: "towin=@", name: "tricep core chest bicep hamstring legs back Workout" },
        { code: "forthegame$", name: "forearm core arm tricep shoulder chest leg abs arm chest chest Workout" },
        { code: "gamemode=+", name: "leg abs arm chest arm core back chest Workout" },
        { code: "allcode*", name: "abs leg leg chest core back chest Workout" },
        { code: "verykewl!", name: "calves chest arm thigh back chest chest leg Workout" },
        { code: "pushit&", name: "trap glute shoulder shoulder bicep tricep shoulder Workout" },
        { code: "quickroll", name: "quad glute bicep back arm core leg leg Workout" },
        { code: "notsure$", name: "hamstring core tricep shoulder glute arm chest chest Workout" },
        { code: "uwin<>", name: "glute chest bicep hamstring Workout" },
        { code: "justlift[]", name: "hip glute shoulder tricep leg bicep forearm tricep quad hamstring Workout" },
        { code: "youtrain!", name: "thigh core glute tricep arm abs bicep hamstring overall Workout" },
        { code: "zebrawork!", name: "oblique chest back arm abs chest core arm back Workout" },
        { code: "!thatsall$", name: "overall tricep shoulder arm tricep shoulder abs leg leg chest Workout" },
        { code: "flowbig@", name: "forearm leg core chest back bicep leg back Workout" },
        { code: "xbackx", name: "back back abs chest back back Workout" },
        { code: "&armsrule&", name: "shoulder abs arm arm shoulder arm glute leg chest shoulder Workout" },
        { code: "*star*", name: "arm shoulder tricep abs arm arm Workout" },
        { code: "(curl)", name: "bicep chest glute arm leg tricep Workout" },
        { code: ")tripush)", name: "tricep tricep arm bicep trap glute shoulder shoulder Workout" },
        { code: "-pushpull", name: "forearm trap shoulder shoulder trap glute leg leg Workout" },
        { code: "+thewin", name: "abs tricep shoulder chest chest bicep hamstring Workout" },
        { code: "=funstuff", name: "legs forearm glute hamstring shoulder tricep glute forearm forearm Workout" },
        { code: "[]you*", name: "quad hamstring thigh core glute arm Workout" },
        { code: "]inthecage!", name: "hamstring bicep hamstring tricep shoulder chest chest abs leg chest Workout" },
        { code: "{pushit{}", name: "glute trap glute shoulder shoulder bicep tricep glute calve Workout" },
        { code: "}because{", name: "calve back chest chest abs glute shoulder chest glute Workout" },
        { code: ":thenew$", name: "trap tricep chest hamstring chest chest chest Workout" },
        { code: ";yepgo", name: "oblique thigh chest trap leg core Workout" },
        { code: "|fullbody!", name: "hip forearm glute leg leg back core core thigh overall Workout" },
        { code: "<insideroll*", name: "thigh bicep hamstring shoulder bicep core chest arm core leg leg arm Workout" },
        { code: ">toeasy<", name: "overall tricep core chest abs shoulder thigh thigh Workout" },
        { code: "~work^", name: "leg chest core arm back arm Workout" },
        { code: "simple&*", name: "shoulder bicep arm trap leg chest shoulder arm Workout" },
        { code: "@backroll", name: "back back abs chest back arm core leg leg Workout" },
        { code: "det*^", name: "core chest tricep arm arm Workout" },
        { code: "^liftit", name: "arm leg bicep forearm tricep bicep tricep Workout" },
        { code: "_legpower", name: "shoulder leg chest leg trap core chest chest arm Workout" }
    ];

    // Muscle groups mapping (ALL from Android app - combines all categories)
    const muscleGroups = [
        { name: "legband", code: "l" }, { name: "chestband", code: "c" }, { name: "backband", code: "b" },
        { name: "coreband", code: "o" }, { name: "armband", code: "r" }, { name: "shoulderband", code: "s" },
        { name: "chest", code: "e" }, { name: "back", code: "k" }, { name: "shoulder", code: "h" },
        { name: "arm", code: "m" }, { name: "bicep", code: "i" }, { name: "tricep", code: "t" },
        { name: "forearm", code: "f" }, { name: "legs", code: "g" }, { name: "abs", code: "a" },
        { name: "calves", code: "v" }, { name: "trap", code: "p" }, { name: "quad", code: "q" },
        { name: "hamstring", code: "n" }, { name: "glute", code: "u" }, { name: "hip", code: "j" },
        { name: "thigh", code: "y" }, { name: "oblique", code: "z" }, { name: "overall", code: "!" },
        { name: "chestgym", code: "$" }, { name: "backgym", code: "x" }, { name: "shouldergym", code: "&" },
        { name: "armgym", code: "*" }, { name: "bicepgym", code: "(" }, { name: "tricepgym", code: ")" },
        { name: "forearmgym", code: "-" }, { name: "abgym", code: "+" }, { name: "leggym", code: "=" },
        { name: "quadgym", code: "[" }, { name: "hamgym", code: "]" }, { name: "glutegym", code: "{" },
        { name: "calvegym", code: "}" }, { name: "trapgym", code: ":" }, { name: "obliquegym", code: ";" },
        { name: "hipgym", code: "|" }, { name: "thighgym", code: "<" }, { name: "overallgym", code: ">" },
        { name: "legbody", code: "~" }, { name: "chestbody", code: "w" }, { name: "backbody", code: "@" },
        { name: "corebody", code: "d" }, { name: "armbody", code: "^" }, { name: "shoulderbody", code: "_" }
    ];

    const allowedChars = "lcborsekhitfgavpqnujyz!$x&*()-+=[]{}:;|<>~w@d^_";

    // Handle adding character to input
    const addCharacter = (char) => {
        const newInput = userInput + char;
        const lastThreeChars = newInput.slice(-3);

        // Prevent three consecutive same characters
        if (lastThreeChars.length < 3 || !(lastThreeChars[0] === lastThreeChars[1] && lastThreeChars[1] === lastThreeChars[2])) {
            setUserInput(newInput);
        }
    };

    // Handle input change
    const handleInputChange = (e) => {
        const input = e.target.value.toLowerCase();
        const validInput = input.split('').filter(char => allowedChars.includes(char)).join('');

        // Check for three consecutive same characters
        let result = '';
        for (let i = 0; i < validInput.length; i++) {
            const char = validInput[i];
            const lastThreeChars = result.slice(-2) + char;
            if (lastThreeChars.length < 3 || !(lastThreeChars[0] === lastThreeChars[1] && lastThreeChars[1] === lastThreeChars[2])) {
                result += char;
            }
        }

        setUserInput(result);
    };

    // Handle preset workout selection
    const handlePresetSelect = (workoutCode) => {
        setUserInput(workoutCode);
    };

    // Handle next button with URL encoding fix
    const handleNext = () => {
        if (userInput.trim() !== '') {
            // Navigate with properly encoded workout code
            const encodedWorkoutCode = encodeURIComponent(userInput);
            navigate(`/everything-rep-count/${encodedWorkoutCode}`, {
                state: {
                    workoutCode: userInput, // Pass unencoded version in state
                    workoutType: 'everything'
                }
            });
        }
    };

    // Generate random background image
    const getRandomBackground = () => {
        const randomIndex = Math.floor(Math.random() * 88) + 1;
        return `url(/assets/images/v${randomIndex}.jpg)`;
    };

    // Three row character display component
    const ThreeRowCharacterGrid = () => {
        const chunkSize = Math.ceil(allowedChars.length / 3);
        const rows = [];
        for (let i = 0; i < allowedChars.length; i += chunkSize) {
            rows.push(allowedChars.slice(i, i + chunkSize));
        }

        return (
            <div className="three-row-character-grid">
                {rows.map((row, rowIndex) => (
                    <div key={rowIndex} className="character-row">
                        {row.split('').map((char, charIndex) => (
                            <button
                                key={`${rowIndex}-${charIndex}`}
                                className="character-button-row"
                                onClick={() => addCharacter(char)}
                            >
                                {char}
                            </button>
                        ))}
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div
            className="everything-selection-container"
            style={{
                backgroundImage: getRandomBackground(),
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            }}
        >
            {/* Dark overlay */}
            <div className="everything-overlay"></div>

            {/* Fixed top bar */}
            <div className="everything-top-bar">
                <button
                    className="everything-back-button"
                    onClick={() => navigate('/')}
                >
                    ← Back
                </button>

                <input
                    type="text"
                    className="everything-input"
                    value={userInput}
                    onChange={handleInputChange}
                    placeholder="Enter everything code..."
                />

                <button
                    className="everything-next-button"
                    onClick={handleNext}
                    disabled={userInput.trim() === ''}
                >
                    Next 🌟
                </button>
            </div>

            {/* Scrollable content */}
            <div className="everything-content">
                <div className="everything-header">
                    <h1>🌟 EVERYTHING ALL MOVES 🌟</h1>
                    <p>The ultimate comprehensive training experience!</p>
                </div>

                {/* Muscle group buttons */}
                <div className="muscle-groups-grid">
                    {muscleGroups.map((group) => (
                        <button
                            key={group.code}
                            className="muscle-group-button"
                            onClick={() => addCharacter(group.code)}
                        >
                            <span className="muscle-code">{group.code}</span>
                            <span className="muscle-name">{group.name}</span>
                        </button>
                    ))}
                </div>

                {/* Three-row character selector */}
                <div className="character-selector">
                    <h3>Quick Character Input:</h3>
                    <ThreeRowCharacterGrid />
                </div>

                {/* Preset everything workouts */}
                <div className="preset-workouts">
                    <h3>🎆 Ultimate Everything Presets 🎆</h3>
                    <div className="preset-workouts-grid">
                        {everythingWorkouts.map((workout, index) => (
                            <div
                                key={`${workout.code}-${index}`}
                                className="preset-workout-card"
                                onClick={() => handlePresetSelect(workout.code)}
                            >
                                <div className="preset-code">{workout.code}</div>
                                <div className="preset-name">{workout.name}</div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="everything-instructions">
                    <p>🌟 All equipment types in one mega workout!</p>
                    <p>🎆 Bands, bodyweight, gym, and advanced moves combined</p>
                    <p>🚀 The ultimate challenge for fitness enthusiasts!</p>
                </div>
            </div>
        </div>
    );
};

export default EverythingSelection;